import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Motion";
import { ANSWER_FIRST } from "../lib/seoData";

// Prominent, quotable "answer-first" definition placed high on area pages (AEO/GEO).
export const AnswerLead = ({ pageKey }) => {
  const { lang } = useLang();
  const text = ANSWER_FIRST[pageKey] && ANSWER_FIRST[pageKey][lang];
  if (!text) return null;

  return (
    <section className="border-t border-white/10 bg-obsidian-soft py-14 md:py-20" data-testid={`answer-lead-${pageKey}`}>
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <p className="max-w-4xl border-l-2 border-champagne pl-6 font-serif text-xl font-light leading-relaxed text-white/90 md:pl-8 md:text-2xl">
            {text}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default AnswerLead;
